import { ServiceResponse } from "./api.types";
import { api } from "./axios";

export interface PatientDraftResponse {
  id: number;
  insuranceGroup: string | null;
  insuranceGroupName: string | null;
  insuranceGroupResolved: boolean;
  readyToFinalize: boolean;
  emailExists: boolean;
  patientData: Record<string, unknown>;
  finalizedAt: string | null;
}

export interface FinalizePatientDraftResponse {
  id: string;
  fullName: string;
  email: string;
  groupName: string | null;
  bookingToken: string | null;
}

export const syncPatientDraft = async (
  sessionId: string,
  patientData: Record<string, unknown>,
) => {
  const { data } = await api.patch<ServiceResponse<PatientDraftResponse>>(
    `backoffice/patients/drafts/${sessionId}`,
    patientData,
  );
  return data.data;
};

export const finalizePatientDraft = async (
  sessionId: string,
  patientData?: Record<string, unknown>,
) => {
  const { data } = await api.post<
    ServiceResponse<FinalizePatientDraftResponse>
  >(`backoffice/patients/drafts/${sessionId}/finalize`, patientData);
  return data.data;
};
